import React, { useMemo, useState } from 'react';
import { withTranslation } from '@i18n';
import { PlusIcon, MinusIcon } from '@images/svg/index';
import { BulletList } from '@components/index';
import {
  StyledDetailsCover,
  StyledMainHeadline,
  StyledTitleWrapper,
  StyledTitle,
  StyledIconWrapper,
  StyledDescription,
  StyledCardWrapper
} from './styles';

const TreatmentInfoCard = ({ t, data }) => {
  const [displayDescription, setDisplayDescription] = useState(0);
  const cost_details = useMemo(() => (data?.cost_details ? data.cost_details.split('\n') : []), [
    data
  ]);
  const inclusions = useMemo(() => (data?.inclusions ? data.inclusions.split('\n') : []), [data]);
  const exclusions = useMemo(() => (data?.exclusions ? data.exclusions.split('\n') : []), [data]);
  const extra_options = useMemo(() => (data?.extra_options ? data.extra_options.split('\n') : []), [
    data
  ]);
  const safety_notes = useMemo(() => (data?.safety_notes ? data.safety_notes.split('\n') : []), [
    data
  ]);

  const details = [
    {
      title: 'Package Description',
      content: data.description,
      id: '0-description'
    },
    {
      title: 'Cost Details',
      id: '1-cost_details',
      content: cost_details
    },
    {
      title: 'Inclusions',
      id: '2-Inclusions',
      content: inclusions
    },
    {
      title: 'Exclusions',
      id: '3-Exclusions',
      content: exclusions
    },
    {
      title: 'Extra Options',
      id: '4-extra_options',
      content: extra_options
    },
    {
      title: 'Safety Measures',
      id: '5-safety_notes',
      content: safety_notes
    }
  ];

  return (
    <StyledDetailsCover>
      <StyledMainHeadline>{t('PackageDetials')}</StyledMainHeadline>
      {details.map(
        (desc, index) =>
          desc.content.length > 0 && (
            <StyledCardWrapper key={desc.id} active={index === displayDescription}>
              <StyledTitleWrapper
                onClick={() => {
                  setDisplayDescription(index === displayDescription ? false : index);
                }}
              >
                <StyledTitle active={index === displayDescription}>{desc.title}</StyledTitle>
                <StyledIconWrapper active={index === displayDescription}>
                  {index === displayDescription ? <MinusIcon /> : <PlusIcon />}
                </StyledIconWrapper>
              </StyledTitleWrapper>
              <StyledDescription active={index === displayDescription}>
                {index === 0 ? (
                  <div dangerouslySetInnerHTML={{ __html: desc.content }} />
                ) : (
                  <BulletList bullets={desc.content} />
                )}
              </StyledDescription>
            </StyledCardWrapper>
          )
      )}
    </StyledDetailsCover>
  );
};

export default withTranslation('ProfilePackages')(TreatmentInfoCard);
